import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { WizardFooterComponent } from './wizard-footer.component';

@NgModule({
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [WizardFooterComponent],
    declarations: [WizardFooterComponent],
    providers: [],
})
export class WizardFooterModule {}
